export default __webpack_public_path__ + "static/media/drone9.5c4998ce.jpg";